import classNames from 'classnames';
import { StatusLabel } from 'components/common-form/sidePanel/status/initialized/StatusLabel';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

import type { InitializedStatusProps } from './InitializedStatus.connect';
import { connectInitializedStatus } from './InitializedStatus.connect';

export const Component: FC<InitializedStatusProps> = ({ isLoading, isReadyToApplyTradeAllocations }) => (
  <>
    {isLoading && <StatusSkeleton color="secondary" />}
    {!isLoading && isReadyToApplyTradeAllocations && (
      <StatusLabel labelKey="tradeAllocation.sidePanel.status.ready" color="info" />
    )}
    {!isLoading && !isReadyToApplyTradeAllocations && (
      <StatusLabel labelKey="tradeAllocation.sidePanel.status.notReady" color="secondary" />
    )}
  </>
);

const StatusSkeleton: FC<{ color: 'info' | 'secondary' }> = ({ color }) => (
  <div className={classNames('w-100 alert alert-discreet-primary d-flex mb-0 px-0 position-relative', `text-${color}`)}>
    <div className="card-body">
      <span className="pe-2">
        <Skeleton width="1em" />
      </span>
      <Skeleton width="15em" />
    </div>
  </div>
);
export const InitializedStatus = connectInitializedStatus(Component);

InitializedStatus.displayName = 'InitializedStatus';
